module.exports = __webpack_public_path__ + "static/media/5DPO13.a8024959.jpg";